/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorYogaSessionTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorYogaSession,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Stretch Together!",
    "Outdoor Yoga Session Awaits!",
    "Find Your Zen in Nature!",
  ],
  title: "Outdoor Yoga Session",
  description: "Organize a relaxing outdoor yoga session.",
  longDescription:
    "Gather your friends for a peaceful outdoor yoga session! Choose a date, decide on yoga styles, and plan refreshments!",
  emoji: "🧘",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Yoga Session",
          emoji: "🧘",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the outdoor yoga session?",
          emoji: "📅",
          completeAction: {
            question: "Decide on yoga styles to practice?",
            description:
              "What yoga styles should we focus on during the session?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What yoga styles should we consider?",
                emoji: "🧘",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we plan for the session?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Find Our Inner Peace!",
    outroDescription:
      "Your outdoor yoga session plans are set! Enjoy the tranquility!",
  },
};
